import { create } from 'zustand';
import { API_BASE_URL } from '../api/getApiURL';

const useSettingsStore = create((set) => ({
  notice: '',
  hero_bg_color: '',
  hero_text_color: '',
  btn_bg_color: '',
  btn_text_color: '',

  setNotice: (newNotice) => set({ notice: newNotice }),
  setHeroBgColor: (color) => set({ hero_bg_color: color }),
  setHeroTextColor: (color) => set({ hero_text_color: color }),
  setBtnBgColor: (color) => set({ btn_bg_color: color }),
  setBtnTextColor: (color) => set({ btn_text_color: color }),

  fetchSettings: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/settings`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      // Store all the fetched settings in Zustand
      set({
        notice: data.notice || '',
        hero_bg_color: data.hero_bg_color || '',
        hero_text_color: data.hero_text_color || '',
        btn_bg_color: data.btn_bg_color || '',
        btn_text_color: data.btn_text_color || '',
      });
    } catch (error) {
      console.error("Failed to fetch settings:", error);
    }
  }
}));

export default useSettingsStore;
